module.exports = __webpack_public_path__ + "img/arrow-left.d886ca94.svg";